import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { getUnlinkCustomerIcneaUrl } from "./api-url.constants";
import { UnlinkCustomerIcneaError } from "./errors";

export const unlinkCustomerIcnea = async (userId?: string): Promise<void> => {
  const response = await typedFetch(getUnlinkCustomerIcneaUrl(userId), {
    method: API_METHODS.DELETE,
  });

  if (!response.ok) throw new UnlinkCustomerIcneaError();
};
